import {
  CopyOutlined,
  DeleteOutlined,
  FileExcelOutlined,
  InfoCircleFilled,
  InfoCircleOutlined,
  LineChartOutlined,
  MailOutlined,
  MessageOutlined,
  SaveOutlined,
  SearchOutlined,
  SyncOutlined,
  TagOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Avatar,
  Button,
  Card,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  notification,
  Popconfirm,
  Popover,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import copy from "copy-to-clipboard";
import { ExportToCsv } from "export-to-csv";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";

import { getSupaClient, getWorkspace } from "../../lib/supabase";
import { setTeamTagsData } from "../../redux/actions";
import BotMessages from "../BotQuestions/BotQuestions";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import MemberTags from "../MemberTags/MemberTags";
import SendDM from "../SendDM/SendDM";
import { useTagsContext } from "../TagsContext/TagsContext";
import BulkEdit from "./BulkEdit";
import MemberDetail from "./MemberDetail";

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";

const { Option } = Select;
/**
 *
 * @param {
 *  deleteTab
 *  description - text description
 * }
 * @returns
 */

const UserTable = (props) => {
  // props.teamId
  // props.allUsers
  // props.otherColumns
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(false);
  const [isMemberSelected, setIsMemberSelected] = useState(false);
  const [selectedMember, setSelectedMember] = useState();
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedMembersId, setSelectedMembersId] = useState([]);
  const [isMassDmVisible, setIsMassDmVisible] = useState(false);
  const [isSendSurveyVisible, setIsSendSurveyVisible] = useState(false);
  // const [isBulkEditModalVisible, setIsBulkEditModalVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  // const [teamTags, setTeamTags] = useState([]);
  const [isUserModalVisibile, setIsUserModalVisibile] = useState(false);
  const [tableFiltered, setTableFiltered] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState();
  const [isAtRiskVisible, setIsAtRiskVisible] = useState(false);
  const [timezones, setTimezones] = useState([]);

  const selectEl = useRef(null);
  const selectEll = useRef(null);

  const teamTags = useSelector((state) => state.teamTags.team_tags);
  const dispatch = useDispatch();

  const [filterSearch, setfilterSearch] = useState({
    email: "",
    tags: [],
    exTags: [],
    timezones: [],
  });

  const { isBulkEditModalVisible, setIsBulkEditModalVisible } =
    useTagsContext();

  /**
   * Gets the timezones for all the team's users, without duplicates
   */

  const getTimezones = () => {
    let allTimezones = props.allUsers.map((item) => item.tz_label);
    allTimezones = new Set(allTimezones);
    allTimezones = Array.from(allTimezones);
    setTimezones(allTimezones);
  };

  const loadTeamTags = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("tags")
      .select("id, name, color")
      .eq("team", props.teamId);
    if (data) {
      // setTeamTags(data);
      dispatch(setTeamTagsData(data));
      setLoading(false);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  const loadPageData = async () => {
    setLoading(true);
    await Promise.all([loadTeamTags()]);
    setLoading(false);
  };

  useEffect(() => {
    getTimezones();
    setDataSource(props.allUsers);
  }, [props.allUsers]);

  const teamTagsChange = (record) => {
    console.log("Team tags added", record);
    const updatedTags = [...teamTags, record];
    dispatch(setTeamTagsData(updatedTags));

    // setTeamTags(
    //   teamTags.concat({ id: record.id, name: record.name, color: record.color })
    // );
  };

  const showUserModal = async (record) => {
    setIsUserModalVisibile(true);
    // setIsUserDetailLoading(true);
    window.analytics.track("User modal opened");
    setSelectedMember(record);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    console.log("selectedKeys:", selectedKeys);
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // markDone(selectedRows[0])
      // console.log(selectedRowKeys, selectedRows);
      setSelectedMembers(selectedRows);

      if (selectedRowKeys.length > 0) {
        setIsMemberSelected(true);
      } else {
        setIsMemberSelected(false);
      }
    },
  };

  const sendMassDm = () => {
    const ids = selectedMembers.map((member) => member.slack_id);
    // console.log(ids, selectedMembers);
    if (ids.length > 100) {
      console.log("ids", ids.length);
      message.error(
        "You can only DM to 100 members at a time due to Slack's limit. Please schedule in batches of 100 - each batch 5 mins apart"
      );
    } else {
      setSelectedMembersId(ids);
      setIsMassDmVisible(true);
    }
  };

  const sendSurvey = () => {
    const ids = selectedMembers.map((member) => {
      return { id: member.slack_id, name: member.name };
    });
    // console.log(ids, selectedMembers);
    if (ids.length > 100) {
      console.log("ids", ids.length);
      message.error(
        "You can only send survey to 100 members at a time due to Slack's limit. Please schedule in batches of 100 - each batch 5 mins apart"
      );
    } else {
      setSelectedMembersId(ids);
      setIsSendSurveyVisible(true);
    }
  };

  const bulkTagMembers = () => {
    // console.log("selected members", selectedMembers);
    setIsBulkEditModalVisible(true);
  };

  const handelOnchange = (e) => {
    const currentValue = e.target.value.toLowerCase();
    const { name } = e.target;
    const prevFilterInputs = { ...filterSearch };
    const prevFilterData = {
      ...prevFilterInputs,
      [name]: currentValue,
    };
    setfilterSearch(prevFilterData);
  };

  const handleTimezoneChange = (value) => {
    const prevFilterInputs = { ...filterSearch };
    const prevFilterData = {
      ...prevFilterInputs,
      timezones: value,
    };
    setfilterSearch(prevFilterData);
    selectEl.current.blur();
  };

  const handleTagChange = (value) => {
    const prevFilterInputs = { ...filterSearch };
    const prevFilterData = {
      ...prevFilterInputs,
      tags: value,
    };
    setfilterSearch(prevFilterData);
    selectEl.current.blur();
  };

  const handleExTagChange = (value) => {
    const prevFilterInputs = { ...filterSearch };
    const prevFilterData = {
      ...prevFilterInputs,
      exTags: value,
    };
    setfilterSearch(prevFilterData);
    selectEll.current.blur();
  };

  const handleFilterSearch = (e) => {
    e.preventDefault();
    setVisible(false);
    const filteredRecords = props.allUsers.filter((record) => {
      let emailFilter = true;
      let incTagsFilter = true;
      let excTagsFilter = true;
      let timezonesFilter = true;

      const email = record?.email?.toLowerCase();
      const incTags = record?.tags?.filter((tag) =>
        filterSearch.tags.includes(tag?.name)
      );
      const excTags = record?.tags?.filter((tag) =>
        filterSearch.exTags.includes(tag?.name)
      );
      const timezone = filterSearch.timezones.includes(record?.tz_label); // <---- true / false

      if (filterSearch?.tags.length > 0) {
        if (incTags && incTags.length) {
          incTagsFilter = true;
        } else {
          incTagsFilter = false;
        }
      }
      if (filterSearch?.exTags.length > 0) {
        if (excTags && excTags.length) {
          excTagsFilter = false;
        } else {
          excTagsFilter = true;
        }
      }

      if (filterSearch?.email) {
        if (email.includes(filterSearch.email)) {
          emailFilter = true;
        } else {
          emailFilter = false;
        }
      }

      if (filterSearch?.timezones.length > 0) {
        if (timezone) {
          timezonesFilter = true;
        } else {
          timezonesFilter = false;
        }
      }
      return emailFilter && incTagsFilter && excTagsFilter && timezonesFilter;
    });
    setDataSource(filteredRecords);
  };

  const handleFilterReset = () => {
    setVisible(false);
    setfilterSearch({ email: "", tags: [], exTags: [], timezones: [] });
    setDataSource(props.allUsers);
  };

  const handleVisibleChange = (visibleObj) => {
    setVisible(visibleObj);
  };

  const inputStyle = { width: "260px", borderRadius: 10, marginBottom: 8 };
  const spaceStyle = { display: "flex", justifyContent: "space-between" };
  const filterAddSearch = (
    <div style={{ padding: 12, display: "flex", flexDirection: "column" }}>
      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Email</span>
        <Input
          placeholder="Search email"
          name="email"
          value={filterSearch.email}
          onChange={handelOnchange}
          style={{ marginBottom: 8, marginLeft: 0, width: "260px" }}
        />
      </Space>
      <Space style={spaceStyle}>
        <span>Include tags</span>
        <Select
          mode="multiple"
          showArrow
          value={filterSearch.tags}
          ref={selectEl}
          style={inputStyle}
          onChange={handleTagChange}
          placeholder="Select one or more tags"
        >
          {teamTags.map((item) => {
            return (
              <Option key={item.id} value={item.name} name={item.name}>
                <Tag
                  style={{
                    border: `0.5px solid ${item.color}`,
                    borderRadius: 5,
                    borderWidth: "thin",
                    width: "fit-content",
                  }}
                >
                  {item.name}
                </Tag>
              </Option>
            );
          })}
        </Select>
      </Space>

      <Space style={spaceStyle}>
        <span>Exclude tags</span>
        <Select
          mode="multiple"
          value={filterSearch.exTags}
          showArrow
          ref={selectEll}
          style={inputStyle}
          onChange={handleExTagChange}
          placeholder="Select one or more tags"
        >
          {teamTags.map((item) => {
            return (
              <Option key={item.id} value={item.name} name={item.name}>
                <Tag
                  style={{
                    border: `0.5px solid ${item.color}`,
                    borderRadius: 5,
                    borderWidth: "thin",
                    width: "fit-content",
                  }}
                >
                  {item.name}
                </Tag>
              </Option>
            );
          })}
        </Select>
      </Space>
      <Space style={spaceStyle}>
        <span>Timezones</span>
        <Select
          mode="multiple"
          value={filterSearch.timezones}
          showArrow
          ref={selectEll}
          style={inputStyle}
          onChange={handleTimezoneChange}
          placeholder="Select one or more timezones"
        >
          {timezones.map((item, index) => {
            return (
              <Option key={item} value={item} name={item}>
                <Tag style={{ width: "fit-content" }}>{item}</Tag>
              </Option>
            );
          })}
        </Select>
      </Space>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 15,
        }}
      >
        <Button
          size="small"
          style={{ width: 90, marginRight: 6 }}
          onClick={handleFilterReset}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          style={{ width: 90 }}
          onClick={handleFilterSearch}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  const basicMetrics = (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Total Members: <p>{props.totalMembers}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Messages Sent: <p>{props.messagesSent}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Active this period: <p>{props.activeThisPeriod}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Reactions added: <p>{props.reactionAdded}</p>
      </div>
    </div>
  );

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // eslint-disable-next-line no-unused-vars
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ fontSize: 20, color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "";
    },
    onFilterDropdownVisibleChange: () => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const getColumnSearchPropsTags = () => ({
    filterDropdown: () => (
      <div style={{ padding: 8, display: "flex", flexDirection: "column" }}>
        <Select
          mode="multiple"
          showArrow
          value={filterSearch.tags}
          style={inputStyle}
          ref={selectEl}
          onChange={handleTagChange}
          placeholder="Select one or more tags"
        >
          {teamTags.map((item) => {
            return (
              <Option key={item.id} value={item.name} name={item.name}>
                <Tag
                  style={{
                    border: `0.5px solid ${item.color}`,
                    borderRadius: 5,
                    borderWidth: "thin",
                    width: "fit-content",
                  }}
                >
                  {item.name}
                </Tag>
              </Option>
            );
          })}
        </Select>
        <Space>
          <Button
            type="primary"
            onClick={handleFilterSearch}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={handleFilterReset}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ fontSize: 20, color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilterDropdownVisibleChange: () => {},
  });

  const sortTags = (a, b) => {
    const aIds = a ? a.map((tag) => tag.id).sort() : [];
    const bIds = b ? b.map((tag) => tag.id).sort() : [];
    if (aIds > bIds) return 1;
    if (aIds < bIds) return -1;
    return 0;
  };
  let allUserscolumns = [
    {
      title: "Member",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
      ...filterAddSearch,
      filters: [
        { text: "Admin", value: true },
        { text: "Non-admin", value: false },
      ],
      // onFilter: (value, record) => record.is_admin === value,
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div>
            <Avatar src={record.image_32} style={{ marginRight: 15 }} />
          </div>
          <div style={{ maxWidth: "200px" }}>
            <Tooltip title="Click to view user activity">
              <div
                style={{ color: "#1890ff", cursor: "pointer" }}
                onClick={() =>
                  showUserModal({
                    ...record,
                    user_id: record.slack_id,
                    user_name: record.name,
                  })
                }
                onKeyDown={() =>
                  showUserModal({
                    ...record,
                    user_id: record.slack_id,
                    user_name: record.name,
                  })
                }
                tabIndex={0}
                role="button"
              >
                {record.name}
              </div>
            </Tooltip>
          </div>
        </div>
      ),
      width: "25%",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Tags / Cohorts",
      dataIndex: "tags",
      key: "tags",
      ...getColumnSearchPropsTags("tags"),
      render: (text, record) => (
        <MemberTags
          member={record}
          teamTags={teamTags}
          memberTags={record.tags}
          memberId={record.slack_id}
          onTeamTagAdded={teamTagsChange}
        />
      ),
      sorter: (a, b) => sortTags(a.tags, b.tags),
      width: "25%",
    },
  ];

  if (props.otherColumns) {
    allUserscolumns = allUserscolumns.concat(props.otherColumns);
  }

  const bulkEditOk = () => {
    // console.log("selected members", selectedMembers);
    loadPageData();
    if (props.loadParentData) props.loadParentData();
    setIsBulkEditModalVisible(false);
  };

  const exportMembers = () => {
    const csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      fileName: "Dots exported members",
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    const members = isMemberSelected ? selectedMembers : props.allUsers;
    // console.log("export", members);
    const membersWithTags = members.map((member) => {
      let tags = [];
      if (member.tags_json) {
        tags = member.tags_json.map((e) => e.name).join(", ");
        // console.log(member.tags, tags);
        return {
          ...member,
          tags,
        };
      }
      if (member.tags) {
        tags = member.tags.map((e) => e.name).join(", ");
        // console.log(member.tags, tags);
        return {
          ...member,
          tags,
        };
      }

      return member;
    });
    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(membersWithTags);
    const args = {
      message: `${members.length} members info exported!`,
      duration: 1.5,
    };
    notification.open(args);
    window.analytics.track("CSV export", { members: members.length });
  };

  const copyEmails = () => {
    // console.log("new users", newUsers);
    const members = isMemberSelected ? selectedMembers : props.allUsers;
    const copyUsers = members.map((user) => {
      return user.email;
    });
    // console.log("members", members[0]);
    // console.log(copyUsers.join("\r\n"));
    copy(copyUsers.join("\r\n"));
    const args = {
      message: `${members.length} emails copied!`,
      duration: 1.5,
    };
    notification.open(args);
    window.analytics.track("Emails copied", { members: members.length });
  };

  const copyIds = () => {
    // console.log("new users", newUsers);
    const members = isMemberSelected ? selectedMembers : props.allUsers;
    const copyUsers = members.map((user) => {
      return user.slack_id;
    });
    // console.log(copyUsers.join('\r\n'))
    // console.log("members", members[0]);
    copy(copyUsers.join("\r\n"));
    const args = {
      message: `${members.length} Slack IDs copied!`,
      duration: 1.5,
    };
    notification.open(args);
    window.analytics.track("IDs copied", { members: members.length });
  };

  const Exportmenu = (
    <Menu>
      <Menu.Item key="1" icon={<FileExcelOutlined />} onClick={exportMembers}>
        {isMemberSelected ? "Export selected to CSV" : "Export all to CSV"}
      </Menu.Item>
      <Menu.Item key="2" icon={<CopyOutlined />} onClick={copyIds}>
        {isMemberSelected ? "Copy selected slack IDs" : "Copy all slack IDs"}
      </Menu.Item>
      <Menu.Item key="3" icon={<MailOutlined />} onClick={copyEmails}>
        {isMemberSelected ? "Copy selected emails" : "Copy all slack emails"}
      </Menu.Item>
    </Menu>
  );

  const loadParentPageData = (start, end) => {
    if (props.loadPageData) {
      props.loadPageData(start, end);
    }
    if (props.setStartTime) {
      props.setStartTime(start);
    }
    if (props.setEndTime) {
      props.setEndTime(end);
    }
  };

  /**
   * Save data to custom_at_risk_users
   */
  const handleSaveAtRisk = async () => {
    const workspace = getWorkspace(supabase);
    if (props.riskData) {
      const { data, error } = await supabase
        .from("custom_at_risk_users")
        .update({
          active_period_start: props.riskData.active_period_start,
          inactive_period_start: props.riskData.inactive_period_start,
        })
        .match({ team: props.teamId });
      if (error) {
        console.log(error);
        const riskDataAPI = await supabase.from("custom_at_risk_users").insert({
          team: props.teamId,
          active_period_start: props.riskData.active_period_start,
          inactive_period_start: props.riskData.inactive_period_start,
          workspace,
        });
        if (riskDataAPI.error) message.error("Error in saving!");
        else {
          message.success("Saved!");
          setIsAtRiskVisible(false);
          loadParentPageData();
        }
      } else {
        message.success("Saved!");
        setIsAtRiskVisible(false);
        loadParentPageData();
      }
    }
  };

  /**
   * Close At Risk Modal
   */
  const handleAtRiskCancel = () => {
    setIsAtRiskVisible(false);
  };
  // props.viewId
  return (
    <div>
      <Spin spinning={props.loading}>
        {props.description ? (
          <Alert
            style={{
              marginBottom: 20,
              marginRight: 40,
              marginLeft: 40,
              background: "#e6f7ff",
              borderColor: "#93d6ff",
            }}
            type="info"
            message={props.description}
            action={
              props.atRisk ? (
                <Space direction="vertical">
                  <Button
                    size="small"
                    type="primary"
                    onClick={() => setIsAtRiskVisible(true)}
                  >
                    Edit
                  </Button>
                </Space>
              ) : null
            }
          />
        ) : null}
        <Card
          title={
            <>
              {!props.hideDateRange ? (
                <DateRangePicker
                  loadPageData={loadParentPageData}
                  handleFilterReset={() =>
                    setfilterSearch({
                      email: "",
                      tags: [],
                      exTags: [],
                      timezones: [],
                    })
                  }
                  customOption={{ disabled: false }}
                  rangeOfSelector={{
                    range: "day",
                    selectorDefaultOptions: [
                      { value: 7, disabled: false },
                      {
                        value: 30,
                        disabled: false,
                      },
                    ],
                  }}
                />
              ) : (
                ""
              )}
            </>
          }
          extra={
            <Space>
              <span style={{ fontStyle: "italic", color: "gray" }}>
                (Total members: {tableFiltered || dataSource?.length}{" "}
                {isMemberSelected
                  ? `| Selected: ${selectedMembers.length}`
                  : null}
                )
              </span>
              {isMemberSelected ? (
                <>
                  <Button
                    size="small"
                    onClick={sendSurvey}
                    icon={<MessageOutlined />}
                  >
                    Send Survey
                  </Button>
                  <Button
                    size="small"
                    onClick={sendMassDm}
                    icon={<MessageOutlined />}
                  >
                    Mass DM
                  </Button>
                  <Button
                    icon={<TagOutlined />}
                    size="small"
                    onClick={() => bulkTagMembers()}
                  >
                    Bulk tag members
                  </Button>
                </>
              ) : null}
              {props.showLineChartAnalytics ? (
                <Popover
                  content={basicMetrics}
                  title="Analytics about this cohort over time period"
                  trigger="hover"
                  placement="bottomRight"
                  style={{ backgroundColor: "white" }}
                >
                  <Button size="small" icon={<LineChartOutlined />} />
                </Popover>
              ) : null}
              <Popover
                content={filterAddSearch}
                title="Add a filter"
                trigger="click"
                placement="bottomRight"
                visible={visible}
                onVisibleChange={handleVisibleChange}
                overlayStyle={{
                  width: "420px",
                }}
              >
                <Button type="primary" size="small">
                  Filter
                </Button>
              </Popover>
              <Dropdown overlay={Exportmenu}>
                <Tooltip title="Pick an option below">
                  <Button type="primary" size="small" icon={<SaveOutlined />}>
                    Export
                  </Button>
                </Tooltip>
              </Dropdown>
              {props.deleteTab ? (
                <Popconfirm
                  placement="topLeft"
                  title="Delete this view?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={props.deleteTab}
                >
                  <Button danger size="small">
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              ) : null}
              <Button
                danger
                size="small"
                onClick={() =>
                  props.loadPageData(props.startTime, props.endTime)
                }
              >
                <SyncOutlined />
              </Button>
            </Space>
          }
          bordered={false}
        >
          <div style={{ width: "100%", height: "100%" }}>
            <Spin spinning={loading}>
              <Table
                onChange={(pagination, filters, sorter, extra) => {
                  setTableFiltered(extra.currentDataSource.length);
                }}
                dataSource={dataSource}
                size="small"
                columns={allUserscolumns}
                rowSelection={{ type: "checkbox", ...rowSelection }}
                pagination={{
                  defaultPageSize: 50,
                  showSizeChanger: true,
                  pageSizeOptions: ["50", "100", "200"],
                  position: ["bottomRight", "topRight"],
                }}
              />
            </Spin>
          </div>
        </Card>
        <Modal
          width={1200}
          title={
            selectedMember
              ? `${selectedMember.user_name}'s activity`
              : "Member activity"
          }
          style={{ top: 40, right: 10, borderRadius: 20 }}
          visible={isUserModalVisibile}
          onCancel={() => setIsUserModalVisibile(false)}
          footer={[
            <Button key="submit" onClick={() => setIsUserModalVisibile(false)}>
              Ok
            </Button>,
          ]}
        >
          <MemberDetail slackUser={selectedMember} platform="slack" />
        </Modal>
        <Modal
          title="Bulk edit"
          visible={isBulkEditModalVisible}
          // onOk={bulkEditOk}
          onCancel={() => setIsBulkEditModalVisible(false)}
          footer={[]}
        >
          <BulkEdit selectedMembers={selectedMembers} handleSave={bulkEditOk} />
        </Modal>
        <Modal
          title={`Send DMs to ${selectedMembersId.length} selected members`}
          visible={isMassDmVisible}
          onCancel={() => setIsMassDmVisible(false)}
          footer={null}
        >
          <SendDM
            hideSelectMembers
            closeModal={() => setIsMassDmVisible(false)}
            selectableUsers={props.allUsers}
            sendNow
            selectedUsers={selectedMembersId}
          />
        </Modal>
        <Modal
          title="Edit At Risk Setting"
          visible={isAtRiskVisible}
          onOk={handleSaveAtRisk}
          onCancel={handleAtRiskCancel}
          footer={[
            <Button type="primary" onClick={handleSaveAtRisk}>
              Save
            </Button>,
          ]}
        >
          <Alert
            showIcon
            icon={<InfoCircleFilled style={{ color: "#1979FE" }} />}
            style={{
              marginBottom: 20,
              background: "#e6f7ff",
              borderColor: "#93d6ff",
            }}
            type="info"
            message="You can customize this setting based on your community activity. We
            define at risk members as members that used to be active over a
            certain time period (X days), but in the last Y days they have not
            been active. These are good candidates to re-engage because at some
            point they found the community very helpful. Please reach out to us
            on chat if you need help thinking about what will be the best
            setting for your community!"
          />
          <p>
            Member active in the past X days:{" "}
            <span>
              <Input
                value={props.riskData?.active_period_start}
                onChange={(e) =>
                  props.setRiskData({
                    ...props.riskData,
                    active_period_start: e.target.value,
                  })
                }
                type="number"
                style={{ width: 120 }}
              />
            </span>
          </p>
          <p>
            Member inactive in the past Y days:{" "}
            <span>
              <Input
                onChange={(e) =>
                  props.setRiskData({
                    ...props.riskData,
                    inactive_period_start: e.target.value,
                  })
                }
                value={props.riskData?.inactive_period_start}
                style={{ width: 120 }}
                type="number"
              />
            </span>
          </p>
        </Modal>
        <Modal
          title={`Send Survey to ${selectedMembersId.length} selected members`}
          visible={isSendSurveyVisible}
          onCancel={() => setIsSendSurveyVisible(false)}
          footer={[]}
          width={1100}
        >
          <BotMessages
            closeModal={() => setIsSendSurveyVisible(false)}
            type="sendSurvey"
            selectedUsers={selectedMembersId}
          />
        </Modal>
      </Spin>
    </div>
  );
};

export default UserTable;
